import React from 'react';

const DonateOne = () => {
  return (
    <section className="donate-one">
      <div className="container">
        <div className="donate-one__inner" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="0">
          <div className="row">
            <div className="col-xl-6 col-lg-5">
              <div className="donate-one__left-inner">
                <div className="donate-one__bg-color-1">
                  <div className="donate-one__bg-1" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1400&q=60)' }}></div>
                </div>
                <div className="donate-one-left__carousel owl-theme owl-carousel">
                  <div className="item">
                    <div className="donate-one__left">
                      <div className="donate-one-left__single">
                        <h3 className="donate-one-left__title">This Month’s Impact</h3>
                        <div className="donate-one-left__rised-and-progress">
                          <div className="progress-box">
                            <div className="inner count-box">
                              <div className="bar">
                                <div className="bar-inner count-bar" data-percent="86%">
                                  <div className="count-text">86%</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="donate-one-left__rised-and-goals">
                            <div className="donate-one-left__raised"><span>₦50,000 Raised</span></div>
                            <div className="donate-one-left__goals"><span>₦60,000 Goal</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="donate-one__left">
                      <div className="donate-one-left__single">
                        <h3 className="donate-one-left__title">Total Raised Fund</h3>
                        <div className="donate-one-left__rised-and-progress">
                          <div className="progress-box">
                            <div className="inner count-box">
                              <div className="bar">
                                <div className="bar-inner count-bar" data-percent="82%">
                                  <div className="count-text">82%</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="donate-one-left__rised-and-goals">
                            <div className="donate-one-left__raised"><span>₦62,000 Raised</span></div>
                            <div className="donate-one-left__goals"><span>₦70,000 Goal</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="donate-one__left">
                      <div className="donate-one-left__single">
                        <h3 className="donate-one-left__title">Total Raised Fund</h3>
                        <div className="donate-one-left__rised-and-progress">
                          <div className="progress-box">
                            <div className="inner count-box">
                              <div className="bar">
                                <div className="bar-inner count-bar" data-percent="90%">
                                  <div className="count-text">90%</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="donate-one-left__rised-and-goals">
                            <div className="donate-one-left__raised"><span>₦68,000 Raised</span></div>
                            <div className="donate-one-left__goals"><span>₦75,000 Goal</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="donate-one__left">
                      <div className="donate-one-left__single">
                        <h3 className="donate-one-left__title">Total Raised Fund</h3>
                        <div className="donate-one-left__rised-and-progress">
                          <div className="progress-box">
                            <div className="inner count-box">
                              <div className="bar">
                                <div className="bar-inner count-bar" data-percent="95%">
                                  <div className="count-text">95%</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="donate-one-left__rised-and-goals">
                            <div className="donate-one-left__raised"><span>₦25,000 Raised</span></div>
                            <div className="donate-one-left__goals"><span>₦30,000 Goal</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7">
              <div className="donate-one__right-inner" style={{ minHeight: '275px' }}>
                <div className="donate-one__bg-color-2">
                  <div className="donate-one__bg-2" style={{ backgroundImage: 'url(assets/images/19.jpg)' }}></div>
                </div>
                <div className="donate-one-right__carousel owl-theme owl-carousel" style={{ minHeight: '100%' }}>
                  <div className="item">
                    <div className="donate-one__right">
                      <div className="donate-one__tag"><span>Education</span></div>
                      <h2 className="donate-one__title">Education support for children</h2>
                      <p className="donate-one__text">Your gift equips classrooms, provides supplies, and funds scholarships so children can learn, grow, and thrive.</p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="donate-one__right">
                      <div className="donate-one__tag"><span>Healthcare</span></div>
                      <h2 className="donate-one__title">Community health and medical aid</h2>
                      <p className="donate-one__text">Help us deliver essential medicines, maternal care, and mobile clinics to underserved communities.</p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="donate-one__right">
                      <div className="donate-one__tag"><span>Nutrition</span></div>
                      <h2 className="donate-one__title">Nutritious meals for families</h2>
                      <p className="donate-one__text">We combat hunger through monthly food baskets and school meals that keep children focused and healthy.</p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="donate-one__right">
                      <div className="donate-one__tag"><span>Emergency Relief</span></div>
                      <h2 className="donate-one__title">Rapid response in crises</h2>
                      <p className="donate-one__text">When disaster strikes, Rayyan Aid provides urgent shelter, clean water, and essential supplies to affected families.</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Donate One Single End*/}
      </div>
    </section>
  );
};

export default DonateOne;
